export const tempConfig = {
  specialPickupRate: 0.15,
};
